// extracted by mini-css-extract-plugin
export default {"svcList":"Services_svcList__YkmLv","svc":"Services_svc__kOEjx","no":"Services_no__0IN4B","desc":"Services_desc__bXYjA","chips":"Services_chips__imZQc"};